import React from 'react';
// Components
import MerchMerge from 'components/MerchMerge/MerchMerge';

const ManualMerchMerge: React.FC = () => {
  return <MerchMerge />;
};

export default ManualMerchMerge;
